/* eslint-disable no-restricted-globals */
export default () => {
  self.addEventListener("message", event => {
    if (!event) return;
    const { Normalized_Tag_Exceptions, CIP_Events, CIP_Indexes, Time, Data } = event.data;

    const tagsSheetData = Time.map((time, index) => {
      const item = { Time: time };
      for (const key in Data) {
        item[key] = Data[key][index];
      }
      return item;
    });

    const cipIndexSheetsData = {};

    const sheetName = "CIP Time and Cleaning Indexes";
    cipIndexSheetsData[sheetName] = CIP_Events;
    const CIPTagAbbreviationvMap = {
      normalized_differential_pressure: "DP_Cleanability_Initial",
      normalized_permeate_flow: "PF_Cleanability_Initial",
      normalized_salt_passage: "SP_Cleanability_Initial"
    };
    CIP_Events.map((data, index) => {
      Object.keys(CIP_Indexes).forEach(tagKey => {
        const cleanabilityInitial = CIP_Indexes[tagKey]["Cleanability_Intial"][index];
        cipIndexSheetsData[sheetName][index][CIPTagAbbreviationvMap[tagKey]] = cleanabilityInitial;
      });
    });

    const cleaningRequiredSheetsData = Normalized_Tag_Exceptions;

    postMessage({ tagsSheetData, cleaningRequiredSheetsData, cipIndexSheetsData });
  });
};
